var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.options, function(optionGroup) {
      return _c(
        "div",
        {
          class: [
            "dc-post-grid-option-accordion-group-wrapper",
            {
              open: _vm.openAccordion === optionGroup.parent_term.value
            }
          ]
        },
        [
          optionGroup.options.length > 0
            ? _c(
                "button",
                {
                  staticClass: "dc-post-grid-option-accordion-title",
                  attrs: {
                    type: "button",
                    "aria-expanded":
                      _vm.openAccordion === optionGroup.parent_term.value,
                    id: "options-label-" + optionGroup.parent_term.value,
                    "aria-controls": "options-" + optionGroup.parent_term.value
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.toggleAccordion(optionGroup.parent_term.value)
                    }
                  }
                },
                [_vm._v(_vm._s(optionGroup.parent_term.label))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("OptionsList", {
            class: ["dc-post-grid-option-accordion-group-options"],
            attrs: {
              id: "options-" + optionGroup.parent_term.value,
              role: "region",
              "aria-labelledby":
                "options-label-" + optionGroup.parent_term.value,
              showAllOption: _vm.showAllOption,
              checkedValues: _vm.checkedValues,
              fieldName: _vm.fieldName,
              options: optionGroup.options
            },
            on: { "update-filter": _vm.choose }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }